import templateUrl from './member.html'
import './member.scss'

const ProjectTeamMemberComponent = {
  bindings: {
    member: '<',
    project: '<',
    canRemove: '<?',
    canManageVisibility: '<?',
    isLead: '<?',
    onRemoveMember: '&',
    onVisibilityChanged: '&'
  },
  templateUrl,
  controller: class ProjectTeamMember {
    constructor (ProjectTeamService, EventEmitter, ModalService) {
      'ngInject'
      this._identify = 'ProjectTeamMemberComponent'
      this.ProjectTeamService = ProjectTeamService
      this.EventEmitter = EventEmitter
      this.ModalService = ModalService
    }

    get canBeRemoved () {
      return !!this.canRemove && this.member && this.member.paymentsCount === 0
    }

    get hasWorkroomAccess () {
      return !!(this.member && this.member.workroomVisible)
    }

    toggleMenu ($event) {
      if ($event) $event.stopPropagation()
      this.isMenuOpen = !this.isMenuOpen
    }

    closeMenu () {
      this.isMenuOpen = false
    }

    handleToggleWorkroom () {
      this.closeMenu()
      this.toggleWorkroomVisibility()
    }

    handleRemove () {
      this.closeMenu()
      this.removeMember()
    }

    toggleWorkroomVisibility () {
      if (!this.member || !this.member.expert) return
      const nextValue = !this.hasWorkroomAccess
      const name = this.member.expert.fullName
      const body = nextValue
        ? `Grant workroom access to ${name}? They will become visible to the customer and gain access to the project, comments, attachments and activity stream.`
        : `Revoke workroom access from ${name}? They will no longer be visible to the customer or have access to the project, comments, attachments and activity stream.`

      const config = this.ModalService.generateConfig('confirmation', {
        body,
        rejectButton: {
          label: 'Cancel'
        },
        resolveButton: {
          label: nextValue ? 'Yes, grant access' : 'Yes, revoke access'
        },
      })

      this.ModalService.open(config)
        .then(() => {
          const expertIds = [this.member.expert.id]
          this.ProjectTeamService.updateTeamMemberVisibility(this.project.id, expertIds, nextValue)
            .then(updated => {
              const next = Array.isArray(updated) ? updated[0] : updated
              if (next && typeof next.workroomVisible === 'boolean') {
                this.member.workroomVisible = next.workroomVisible
              } else {
                this.member.workroomVisible = nextValue
              }
              if (this.onVisibilityChanged) {
                this.onVisibilityChanged(this.EventEmitter({ member: this.member }))
              }
            })
        })
    }

    removeMember () {
      const expertIds = [
        this.member.expert.id
      ]

      const config = this.ModalService.generateConfig('confirmation', {
        data: { name: this.member.expert.fullName },
        body: 'Are you sure you want to remove {{ $ctrl.modal.data.name }} from the team?',
        rejectButton: {
          label: 'Cancel'
        },
        resolveButton: {
          label: 'Yes, remove'
        },
      })

      this.ModalService.open(config)
        .then(response => {
          this.ProjectTeamService.removeTeamMember(this.project.id, expertIds)
            .then(response => {
              if (this.onRemoveMember) {
                this.onRemoveMember(this.EventEmitter({ member: this.member }))
              }
            })
        })
    }
  }
}

export default ProjectTeamMemberComponent
